export const inspectTable = [
  {
    id: 1,
    isChecked: ``,
    content: [
      '1',
      '· 직종별(급식,시설관리 청소(미화), 기타) 안전보건 자체 점검표 작성 관리\n' +
      '  ※ 교육청에서 제시한 직종별, 분야별 자체점검표 서식에 따라 자체 점검을 정확히 실시한 경우 "이행"에 해당됨',
      '산업안전보건법 제16조, 제38조, 제39조, 제80조',
    ],
    tooltip: {
      title: '1. 직종별(급식,시설관리 청소(미화), 기타) 안전보건 자체 점검표 작성 관리',
      body: ' - 기계,기구 또는 설비의 안전보건 점검 및 이상 유무의 확인<br/>' +
        '   ※(예시) 보일러,승강기,세척기,톱·예초기 등의 방호 덮개 부착 등<br/>' +
        ' - 작업장 정리·정돈 및 통로 확보에 대한 확인·감독<br/>' +
        ' - 전기 감전을 방지하기 위한 기계·기구 등의 충전부 방호 조치<br/>' +
        ' - 전기 기계·기구의 접지 및 누전차단기 설치,전기배선 피복 및 정리,절연용 보호구 사용 등<br/>' +
        ' - 작업장 바닥의 미끄럼, 넘어짐 방지 조치 및 청결 유지·관리(급식실,화장실,계단,통학차량 바닥 등)<br/>' +
        ' - 작업장,지하실,계단,통로의 적정 조도 확보<br/>' +
        ' - 동력 기계·기구의 회전체 및 칼날 방호장치(덮개)설치 <br/>' +
        ' - 중량물 취급 주의 스티커 부착 <br/>' +
        ' - 중량물 작업 시 보조도구(각종 운반카 등) 사용, 2인 1조 작업 <br/>' +
        ' - 작업 전후 충분한 스트레칭 실시, 작업시간과 휴식시간 적정 배분',
    },
  },
  {
    id: 2,
    isChecked: ``,
    content: [
      '2',
      '· 소속 근로자의 작업복·보호구 및 방호장치의 점검과 그 착용·사용에 관한 교육·지도\n' +
      '  ※ 보호구 등 장비 구비(kcs표시 적격품) 및 점검 대장 작성 관리',
      '산업안전보건법 제16조 및 시행령 제15조 제1항제2호',
    ],
    tooltip: {
      title: '2. 소속 근로자의 작업복·보호구 및 방호장치의 점검과 그 착용·사용에 관한 교육·지도',
      body: ' - 적격품(kcs 표시) 사용 여부<br/>' +
        ' - 보호구 등 장비 구비 및 점검 대장 작성 관리 여부 등<br/>' +
        ' ※ 보호구: (예시) 안전모, 안전화, 안전장갑, (방진,방독,송기)마스크, 전동식 호흡보호구, 보호복, 안전대, (차광, 비산방지)보안경, 용접용 보안면, 귀마개 또는 귀덮개 등)'
    }
  },
  {
    id: 3,
    isChecked: ``,
    content: [
      '3',
      '· 산업재해 보고 및 이에 대한 응급조치 \n' +
      '  ※산업재해 미발생시  "해당없음"',
      '산업안전보건법 제16조,제57조, 시행령 제15조 제1항제3호, 시행규칙 제72조, 제73조',
    ],
    tooltip: {
      title: '3. 산업재해 보고 및 이에 대한 응급조치',
      body: ' - 산업재해조사표 제출: 3일이상 휴업이 필요한 재해 발생 시 1개월 이내에 교육청과 지방고용노동지청에 제출<br/>' +
        ' - 재발방지계획 수립 및 이행, 수시 위험성평가 실시<br/>' +
        '※  근로복지공단에 요양급여신청서를 제출하더라도 산업재해조사표는 별도로 제출하여야 함'
    }
  },
  {
    id: 4,
    isChecked: ``,
    content: [
      '4',
      '· 안전관리자, 보건관리자, 산업보건의 등의 지도·조언(현장, 공문 시행 등)에 대한 이행\n' +
      '  ※ 예시: 학교기본운영비로 피복비·안전보호구 구입, 시설개선 예산편성 및 집행 등',
      '- 산업안전보건법 제16조 및 시행령 제15조 제1항제5호\n' +
      '- 중대재해처벌법 시행령 제4조(안전보건관리체계의 구축 및 이행 조치)',
    ],
    tooltip: {
      title: '4. 안전관리자, 보건관리자, 산업보건의 등의 지도·조언(현장, 공문 시행 등)에 대한 이행',
      body: ' - 중대산업재해 예방 및 산업안전보건과 관련된 요청 사항의 이행 여부<br/>' +
        ' - 안전보건 확보를 위한 예산편성 및 집행 여부'
    }
  },
  {
    id: 5,
    isChecked: ``,
    content: [
      '5',
      '· 중대재해 대응 매뉴얼에 따른 조치 (예시1 또는 예시2 방법 등)\n' +
      '  ※ 예시\n' +
      '   - 1) 실제 중대재해 사고시 매뉴얼에 따라 조치\n' +
      '   - 2) 근로자 교육시 매뉴얼 교육 포함 또는 매년 정례적으로 매뉴얼에 대한 교육 실시 ',
      ' - 산업안전보건법 제16조 및 시행령 제15조 제1항제5호\n' +
      ' - 중대재해처벌법 시행령 제4조 제8호',
    ],
    tooltip: {
      title: '5. 중대재해 대응 매뉴얼에 따른 조치',
      body: ' - 중대산업재해가 발생하거나 발생할 급박한 위험이 있는 경우 대비 "중대재해 대응 매뉴얼" 에 따른 조치 여부<br/>' +
        ' - 행동요령에 대한 교육 및 게시(숙지): 근로자의 작업중지권에 대한 권리보장 포함'
    }
  },
  {
    id: 6,
    isChecked: ``,
    content: [
      '6',
      '· (수시) 위험성평가 실시, 유해·위험요인의 파악 및 개선 조치\n' +
      '· (수시) 근골격계질환 유해요인조사 실시\n' +
      '  ※ 새로운 유형의 업무 추진 시 또는 산업재해 발생 시 수시 위험성평가 실시 및 재발방지계획 수립 필수, 그외는 해당없음',
      '산업안전보건법 제16조, 제36조(위험성평가의 실시) 및 시행령 제15조 제1항제6호',
    ],
    rowType: 'customType',
    customTypes: [3],
    customIndex: 1,
    tooltip: {
      title: '6. (수시) 위험성평가 실시, 유해·위험요인의 파악 및 개선 조치, 근골격계질환 유해요인조사 실시',
      body: ' - (자체평가의 경우) 위험성평가 프로그램(SERA 등) 활용 실행 결과물 및 개선 결과 등<br/>' +
        ' - (위탁의 경우) 용역결과 보고서 및 개선 결과 등<br/>' +
        ' - (수시 위험성 평가) 산업재해 발생 시 해당 분야에 대한 수시 위험성 실시 및 보고'
    }
  },
  {
    id: 7,
    isChecked: ``,
    content: [
      '7',
      '· (도급, 위탁, 용역) \n관계수급인 근로자의 산업재해 예방을 위한 안전 및 보건 시설의 설치 등 안전 및 보건 조치',
      '산업안전보건법 제16조, 제63조(도급인의 안전조치 및 보건조치) 및 시행령 제15조',
    ],
    tooltip: {
      title: '7. (도급, 위탁, 용역) 관계수급인 근로자의 산업재해 예방을 위한 안전 및 보건 시설의 설치 등 안전 및 보건 조치',
      body: ' - 도급 등의 위탁 시 안전보건 확보조치 가이드라인에 따른 적격업체 선정(절차 준수)<br/>' +
        ' - 도급 계약 시 안전관리비 계상 확인 및 안전보건체크리스트 확인<br/>' +
        ' - 도급 분야 위험성 평가 자료 제공 및 수급자의 위험성평가 실시결과 공유 및 조정<br/>' +
        ' - 수급업체에서 인증(KCS 표시)받은 보호구,기계,기구 사용 안내 및 사용여부 확인<br/>' +
        ' -  "중대재해 발생 대응 매뉴얼" 안내 및 급박한 상황 대비 종사자의 작업중지권 안내<br/>' +
        ' - 도급 분야별(급식, 시설관리 청소(미화), 기타) 안전·보건 자체 점검표 작성관리<br/>' +
        ' - 안전관리비 집행 확인과 정산'
    }
  },
  {
    id: 8,
    isChecked: ``,
    content: [
      '8',
      '· (도급, 위탁, 용역) \n' +
      '도급인과 수급인을 구성원으로 하는 안전 및 보건에 관한 협의체 구성 및 운영(월 1회 점검)',
      '산업안전보건법 제16조, 제64조(도급에 따른 산업재해 예방조치)제1항제1호',
    ],
    tooltip: {
      title: '8. (도급, 위탁, 용역) 도급인과 수급인을 구성원으로 하는 안전 및 보건에 관한 협의체 구성 및 운영(월 1회 점검)',
      body: ' - 협의체 구성<br/>' +
        ' - 매월 1회 이상 정기적 회의 개최 및 결과 기록, 보존 '
    }
  },
  {
    id: 9,
    isChecked: ``,
    content: [
      '9',
      '· (도급, 위탁, 용역) \n' +
      '작업장 순회점검 및 합동점검반 구성·운영 실시',
      '산업안전보건법 제16조, 제64조 제1항제2호, 제2항',
    ],
    tooltip: {
      title: '9. (도급, 위탁, 용역) 작업장 순회점검 및 합동점검반 구성·운영 실시',
      body: ' - (합동점검반 구성·운영) 도급인과 수급인 및 각각의 근로자 각 1명으로 구성 및 운영과 분기 1회 이상 점검<br/>' +
        ' - (순회점검) 작업장 주1회 이상 점검 '
    }
  },
  {
    id: 10,
    isChecked: ``,
    content: [
      '10',
      '· (도급, 위탁, 용역) \n' +
      ' 안전보건교육을 위한 장소 및 자료의 제공 등 지원 등 기타 안전보건 조치 ',
      '산업안전보건법 제16조, 제64조 제1항제3호~제7호',
    ],
    tooltip: {
      title: '10. (도급, 위탁, 용역)',
      body: ' - 위생시설 등 설치를 위한 장소 제공 또는 위생시설 이용의 협조<br/>' +
        ' - (도급인과 같은 장소 작업 시) 작업시기 확인 및 조정, 내용, 안전보건 조치등의 확인<br/>' +
        ' - 수급업체 근로자의 안전보건교육 실시 여부 확인 <br/>' +
        ' - 경보체계 운영과 대피방법 등 훈련(작업 장소에서의 발파작업, 화재, 폭발, 토사, 구축물 등의 붕괴 또는 지진등이 발생할 경우 대비)'
    }
  },
  {
    id: 11,
    isChecked: ``,
    content: [
      '11',
      '· (도급, 위탁, 용역) \n' +
      '질식 또는 붕괴위험이 있는 작업을 도급하는 경우 작업 시작 전 수급인에게 안전 및 보건에 관한 정보를 문서로 제공 \n' +
      '  ※  미해당 시 "해당없음"',
      '산업안전보건법 제65조(도급인의 안전 및 보건에 관한 정보 제공 등)',
    ],
    tooltip: {
      title: '11. (도급, 위탁, 용역) 질식 또는 붕괴위험이 있는 작업을 도급하는 경우 작업 시작 전 수급인에게 안전 및 보건에 관한 정보를 문서로 제공 ',
      body: '질식 또는 붕괴 위험이 있는 작업이란 안전보건규칙 별표 18에 따른 밀폐공간에서 작업을 말함'
    }
  },
  {
    id: 12,
    isChecked: ``,
    content: [
      '12',
      '· 산업안전보건법령 요지 및 안전보건관리규정 게시',
      '산업안전보건법 제34조(법령 요지 등의 게시 등)',
    ],
    tooltip: {
      title: '12. 산업안전보건법령 요지 및 안전보건관리규정 게시',
      body: '근로자가 자유롭게 열람할 수 있는 장소에 항상 게시 여부(게시장소 : 게시판, 행정실, 급식실, 시설관리실, 휴게실 등)'
    }
  },
  {
    id: 13,
    isChecked: ``,
    content: [
      '13',
      '· 유해하거나 위험한 장소, 시설, 물질에 대한 경고, 비상 시의 대처, 지시, 안내 등을 그림 또는 기호, 글자 등으로 표시',
      '산업안전보건법 제37조(안전보건표지의 설치 ·부착)',
    ],
    tooltip: {
      title: '13. 유해하거나 위험한 장소, 시설, 물질에 대한 경고, 비상 시의 대처, 지시, 안내 등을 그림 또는 기호, 글자 등으로 표시',
      body: ' 추락,감전,화상,넘어짐,끼임,베임 등(급식실,옥상,전기실,지하실,베란다,통학차량 등)<br/>' +
        ' ※ 산업안전보건 스티커북 활용(서울시교육청 홈페이지-안전총괄담당관-부서업무방 54번)'
    }
  },
  {
    id: 14,
    isChecked: ``,
    content: [
      '14',
      '· 추락 위험장소에 안전난간 설치 및 개구부 등의 방호 조치, 낙하물에 의한 위험방지',
      '산업안전보건법 제38조(안전조치), 산업안전보건기준에 관한 규칙 제13조,제14조,제20조,제42조,제43조',
    ],
    tooltip: {
      title: '14. 추락 위험장소에 안전난간 설치 및 개구부 등의 방호 조치, 낙하물에 의한 위험방지',
      body: ' - 안전난간 설치, 관계자 외 출입금지 및 추락위험 등 안전표지판 부착, 추락방호망 설치 등<br/>' +
        ' - 추락 위험장소 이용 시 안전대, 안전모 등 보호구 착용'
    }
  },
  {
    id: 15,
    isChecked: ``,
    content: [
      '15',
      '· 높은 장소(고소)작업 시 작업 안전수칙 숙지, 보호구 지급\n' +
      '- 시설관리 분야 위험작업 관리대장 작성 및 관리 여부 등',
      '산업안전보건법 제38조(안전조치), 산업안전보건기준에 관한 규칙 제24조,제32조'
    ],
    tooltip: {
      title: '15. 높은 장소(고소)작업 시 작업 안전수칙 숙지, 보호구 지급',
      body: ' - 전도방지장치(아웃트리거)가 장착된 안전사다리 사용, 2인 1조 작업, <br/>' +
        ' - 안전모 및 안전대 착용 등'
    }
  },
  {
    id: 16,
    isChecked: ``,
    content: [
      '16',
      '· 작업환경측정 실시\n' +
      '  (작업환경측정대상 유해인자에 노출되는 근로자가 있는 작업장)\n' +
      '  ※  미해당 시 "해당없음"',
      '산업안전보건법 제125조(작업환경측정), 산업안전보건법 시행규칙 별표21'
    ],
    tooltip: {
      title: '16. 작업환경측정 실시',
      body: '화학물질제품을 용기에 담아 사용시 용기에 경고표시 부착 (산업안전보건 스티커북 활용)'
    }
  },
  {
    id: 17,
    isChecked: ``,
    content: [
      '17',
      '· 정기 위험성평가 실시, 유해·위험요인의 파악 및 개선 조치',
      '산업안전보건법 제16조, 제36조(위험성평가의 실시) 및 시행령 제15조 제1항제6호',
    ],
    rowType: 'customType',
    customTypes: [3],
    customIndex: 1,
    tooltip: {
      title: '17. 정기 위험성평가 실시, 유해·위험요인의 파악 및 개선 조치',
      body: ' - (자체평가의 경우) 위험성평가 프로그램(SERA 등) 활용 실행 결과물 및 개선 결과 등<br/>' +
        ' - (위탁의 경우) 용역결과 보고서 및 개선 결과 등'
    }
  },
  {
    id: 18,
    isChecked: ``,
    content: [
      '18',
      '· 근골격계질환 유해요인조사 실시  \n' +
      '- 정기조사: 매 3년마다\n' +
      '※ 최근 실시일이 3년 이내이면 3년 주기 미도래로 "이행"에 해당. ',
      '산업안전보건법 제39조, 산업안전보건기준에 관한 규칙 제12장',
    ],
    rowType: 'customType',
    customTypes: [3],
    customIndex: 1,
    tooltip: {}
  },
  {
    id: 19,
    isChecked: ``,
    content: [
      '19',
      '· 현업종사자(시설관리, 청소(미화), 급식, 통학보조원) 산업안전보건교육 이수  \n' +
      '(매반기 12시간)',
      '산업안전보건법 제129조(일반건강진단)',
    ],
    tooltip: {}
  },
  {
    id: 20,
    isChecked: ``,
    content: [
      '20',
      '관리감독자 산업안전보건교육 이수(연 16시간)',
      '산업안전보건법 제32조(안전보건관리책임자 등에 관한 직무교육), 시행규칙 제26조(교육시간 및 교육내용)',
    ],
    tooltip: {}
  },
  {
    id: 21,
    isChecked: ``,
    content: [
      '21',
      '일반 건강검진 실시',
      '산업안전보건법 제129조(일반건강진단)',
    ],
    tooltip: {
      title: '21. 일반 건강검진 실시',
      body: ' - 사무직(1회/2년)  비사무직(1회/1년) 건강검진 안내(공람) 및 실시'
    }
  },
];
